import axios from 'axios';
var myaxios = {};
var aass = {};
myaxios.install = function(Vue){
    var axios_obj = axios.create({
        //请求接口
        baseURL: process.env.NODE_ENV === "development" ? window.Glob.qw : window.Glob.qwApi,
    })
    //发送请求前拦载
    axios_obj.interceptors.request.use(function (config) {
        var urlsa = config.url;
        var t = Date.parse(new Date()) / 1000;//时间戳
        var login = window.localStorage.getItem('login');
        var token = window.localStorage.getItem('token');
        if(urlsa.indexOf("?") != -1 ){
            config.url = config.url + "&datest="+t+"&login_name="+login+"&token="+token
        }else{
            config.url = config.url + "?datest="+t+"&login_name="+login+"&token="+token
        }
        return config;
    });

    Vue.prototype.$qwhttp = axios_obj;
}
export default myaxios;



// WEBPACK FOOTER //
// ./src/assets/js/qw-http.js